/**
 * 来款详情
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2021/5/18      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */

import React from 'react'
import PropTypes from "prop-types";
import {Modal,Form,Spin} from "antd";
import Locale from "../../../../../utils/locale";
import ViewImage from '@components/UploadFile/UploadImage/ViewImage';
import {splitNumberRu,toFixed2} from "@utils/utils";
import {toFixedWithCommas} from "../../../../../utils/number-util";
import dayjs from "dayjs";
import "./index.less";
import {renderFileType} from "../../../../../components/UploadFile/UploadImage/file.util";
let locale = Locale.current();
class Detail extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            isVisible:false,
            model:{}
        }
    }

    /**
     * 打开弹窗
     */
    showModal=()=>{
        this.setState({
            isVisible:true
        });
        this.getData();
    }

    onCancel=()=>{
        this.setState({
            isVisible:false
        });
    }

    /**
     * 获取数据
     */
    getData(){
        this.setState({
            loading:true
        }, () =>{
            $.ajax({
                url: "/service/mg/fin/ddp/remittance-item/remittanceInfo",
                type:'post',
                dataType: "json",
                contentType: 'application/json',
                data:JSON.stringify({
                    lang:locale,
                    remittanceId:this.props.id
                }),
                success:(res)=>{
                    let state = {
                        loading:false
                    }
                    if(res.success&&res.valid){
                        state = Object.assign(state,{
                            model:res.model||{}
                        })
                    }
                    this.setState(state);
                }
            });
        });

    }

    render(){
        let {isVisible,loading,model} = this.state;
        let layout = {
            labelCol: { span: 7 },
            wrapperCol: { span: 17 },
            labelAlign:"left"
        };
        if(locale!="zh"){
            layout = {
                labelCol: { span: 10 },
                wrapperCol: { span: 14 },
                labelAlign:"left"
            };
        }
        return (
            <div className="payment-check-in-detail-wrap">
                <span onClick={this.showModal}>{this.props.children}</span>
                <Modal width="597px" centered={true} onCancel={this.onCancel} footer={false} title={__getServerLanguage('LaiKuanXiangQing')} open={isVisible}>
                    <Spin spinning={loading}>
                        <Form
                            ref={this.formRef}
                            {...layout}
                            name="basic"
                        >
                            <Form.Item
                                label={__getServerLanguage('DanJuHao')}
                            >
                                {model.remittanceCode||'-'}
                            </Form.Item>
                            <Form.Item
                                label={__getServerLanguage('KeHu')}
                            >
                                {model.buyerCode||'-'} |  {model.buyerName||'-'}
                            </Form.Item>

                            <Form.Item
                                label={__getServerLanguage('FuKuanFangShi')}
                            >
                                {model.payType?__getServerDictItem(`fin_remittance_item_pay_type.${model.payType}`):"-"}
                            </Form.Item>

                            <Form.Item
                                label={__getServerLanguage('DaoKuanRiQi')}
                            >
                                {model.moneyInTime
                                    ? dayjs(model.moneyInTime).format("YYYY-MM-DD")
                                    : "-"}
                            </Form.Item>

                            <Form.Item
                                label={__getServerLanguage('ShiJiDaoZhangJinE')}
                            >
                                {locale=='ru'?<span>
                                   {model.moneyIn?splitNumberRu(toFixed2(model.moneyIn,2)):'-'} {model.currencySymbol}
                                   </span>:<span>
                                    {model.currencySymbol}{model.moneyIn?toFixedWithCommas(model.moneyIn,2):'-'}
                                </span>}
                            </Form.Item>

                            <Form.Item
                                label={__getServerLanguage('YinHangLiuShuiHao')}
                            >
                                {model.bankSeq||'-'}
                            </Form.Item>

                            <Form.Item
                                label={__getServerLanguage('BeiZhu')}
                            >
                                {model.remark||'-'}
                            </Form.Item>
                            <Form.Item
                                label={__getServerLanguage('ShuiDan')}
                            >
                                {model.fileList&&model.fileList.length>0?<div className={"flex-item"}>
                                    {model.fileList.map(item=><div className={"cursor-p"} onClick={()=>window.open(item.url)}>
                                        {item.url?renderFileType(item.url,80):null}
                                    </div>)}
                                </div>:null}
                            </Form.Item>

                            <Form.Item
                                label={__getServerLanguage('DengJiRen')}
                            >
                                {model.createByName||'-'} | {model.createTime?dayjs(model.createTime).format('YYYY-MM-DD HH:mm'):'-'}
                            </Form.Item>
                        </Form>
                    </Spin>
                </Modal>
            </div>
        )
    }
}

Detail.defaultProps = {
    id:null
}

Detail.propTypes = {

}
export default Detail;
